import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { isBC, isCalls } from 'utils/ident';

import Error404 from 'components/Error404';

const MainPage = lazy(() => import('pages/MainPage'));
const PickTimePage = lazy(() => import('pages/PickTimePage'));
const ConfirmPage = lazy(() => import('pages/ConfirmPage'));
const CardPage = lazy(() => import('pages/CardPage'));
const IdentPage = lazy(() => import('pages/IdentPage'));
// const isCalls = false;
// const isBC = true;
/**
 * Router component
 * ================
 * Configures client-side routing
 * @param {Object} layout props from Layout provider
 * @param {Object} data props from DataLayer provider
 */
const Router = ({ layout, data }) => {
  return (
    <BrowserRouter>
      <Switch>
        {isCalls && (
          <Route
            exact
            path={'/assistant/:callbackID'}
            // path={'/8RrF0GLE'}
            // path={'/ptUgTL1A'}
            // path={'/h8ynDPg6'}
            render={() => (
              <Suspense fallback="">
                <MainPage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )}
        {isCalls && (
          <Route
            exact
            path={'/assistant/:callbackID/pick'}
            render={() => (
              <Suspense fallback="">
                <PickTimePage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )}
        {isCalls && (
          <Route
            exact
            path={'/assistant/:callbackID/ident'}
            render={() => (
              <Suspense fallback="">
                <IdentPage />
              </Suspense>
            )}
          />
        )}
        {isCalls && (
          <Route
            exact
            path={'/assistant/:callbackID/confirm'}
            render={() => (
              <Suspense fallback="">
                <ConfirmPage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )}
        {/* {isLeader && (
          <Route
            exact
            path={'/leader/:callbackID'}
            // path={'/8RrF0GLE'}
            // path={'/ptUgTL1A'}
            // path={'/h8ynDPg6'}
            render={() => (
              <Suspense fallback="">
                <MainPage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )}
        {isLeader && (
          <Route
            exact
            path={'/leader/:callbackID/pick'}
            render={() => (
              <Suspense fallback="">
                <PickTimePage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )}
        {isLeader && (
          <Route
            exact
            path={'/leader/:callbackID/ident'}
            render={() => (
              <Suspense fallback="">
                <IdentPage />
              </Suspense>
            )}
          />
        )}
        {isLeader && (
          <Route
            exact
            path={'/leader/:callbackID/confirm'}
            render={() => (
              <Suspense fallback="">
                <ConfirmPage layout={layout} data={data} />
              </Suspense>
            )}
          />
        )} */}
        {isBC && (
          <Route
            exact
            path={'/bc/:callbackID/bc'}
            // path={'/8RrF0GLE'}
            // path={'/ptUgTL1A'}
            // path={'/h8ynDPg6'}
            render={() => (
              <Suspense fallback="">
                <MainPage layout={layout} data={data} isBC />
              </Suspense>
            )}
          />
        )}
        {isBC && (
          <Route
            exact
            path={'/bc/:callbackID/bc/pick'}
            render={() => (
              <Suspense fallback="">
                <PickTimePage layout={layout} data={data} isBC />
              </Suspense>
            )}
          />
        )}
        {isBC && (
          <Route
            exact
            path={'/bc/:callbackID/bc/ident'}
            render={() => (
              <Suspense fallback="">
                <IdentPage />
              </Suspense>
            )}
          />
        )}
        {isBC && (
          <Route
            exact
            path={'/bc/:callbackID/bc/confirm'}
            render={() => (
              <Suspense fallback="">
                <ConfirmPage layout={layout} data={data} isBC />
              </Suspense>
            )}
          />
        )}
        {isBC && (
          <Route
            exact
            path={'/bc/:cardID'}
            render={() => (
              <Suspense fallback="">
                <CardPage layout={layout} data={data} isBC />
              </Suspense>
            )}
          />
        )}
        <Route component={Error404} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
